import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs SharedMsResourcesModal noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"420px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "MSリソース一覧"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs14 centered text-left",
    style: {"color":"#696969"}
  }, [
    /*#__PURE__*/_createTextVNode(" 調整カレンダーで設定するMSリソースを選択してください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" MSリソースを選択して取り込むと、すべてのユーザーが取り込んだMSリソースを利用できるようになります。 ")
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "MSリソースが見つかりませんでした。", -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "rad8 pad5 mc posRe w100",
  style: {}
}
const _hoisted_14 = { class: "fs14 fl mt10 ml10" }
const _hoisted_15 = { class: "fr" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "w100 rad10"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "fl" }
const _hoisted_21 = { class: "w100 fs14" }
const _hoisted_22 = { class: "w100 fs12 grey" }
const _hoisted_23 = {
  key: 0,
  class: "fr mr10 mt5"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "SharedMsResourcesModal",
    "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideFixScheduleModal && _ctx.hideFixScheduleModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.rm.userInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (!_ctx.cm.msResourcesCtags)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_RoomsLoader)
                    ]))
                  : (_ctx.cm.msResourcesCtags.length == 0)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                            width: "40",
                            height: "40"
                          }, null, 8, _hoisted_12)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.sharedMsResourcesSearchKeys.length || 0) + "/" + _toDisplayString(_ctx.cm.msResourcesCtags.length) + "件選択中 ", 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("button", {
                              class: "fr pointer centered circle_button skyblueBg fs14 rad8 mt5 mr10 padw10",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveMsResources && _ctx.saveMsResources(...args)))
                            }, " 保存 "),
                            _createElementVNode("div", {
                              class: "fr pointer underline fs13 mt15 mr20",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearMsResources && _ctx.clearMsResources(...args)))
                            }, " すべての選択をはずす "),
                            _hoisted_16
                          ]),
                          _hoisted_17,
                          (_ctx.cm.msResourcesCtags.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cm.msResourcesCtags, (ctag) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "pointer hoverLgreyBg rad10 pad10",
                                    key: `${ctag.id}${_ctx.sharedMsResourcesSearchKeys}`,
                                    onClick: ($event: any) => (_ctx.selectMsResource(ctag))
                                  }, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", _hoisted_21, _toDisplayString(ctag.name), 1),
                                      _createElementVNode("div", _hoisted_22, _toDisplayString(ctag.email), 1)
                                    ]),
                                    (_ctx.sharedMsResourcesSearchKeys.includes(ctag.search_key))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                          _createElementVNode("img", {
                                            src: _ctx.$getAssetImageUrl(`/assets/icons/check_green.png`),
                                            width: "20",
                                            height: "20"
                                          }, null, 8, _hoisted_24)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _hoisted_25
                                  ], 8, _hoisted_19))
                                }), 128)),
                                _hoisted_26
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_27
                        ])
                      ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}